import { lazy } from 'react';

const CompanyEdit = lazy(() => import('./CompanyEdit'));

export default CompanyEdit;
